import { formatDate } from "../utils";

export interface NormalizedNotification {
  id: number | string;
  type: string;
  title: string;
  message: string;
  date: string;
  createdAt?: string;
  updatedAt?: string;
  status?: string;
}

const DEFAULT_TYPE = "INFORMATION";

export const normalizeNotificationItem = (item: any): NormalizedNotification | null => {
  if (!item) return null;
  const rawMessage = item.message ?? "";
  const createdAt = item.createdAt ?? item.updatedAt;
  const normalizedDate = formatDate(createdAt);
  const trimmedRaw = rawMessage.trim();
  if (trimmedRaw.includes("/-/")) {
    const parts = trimmedRaw.split("/-/").map((part: string) => part.trim());
    if (parts.length >= 4) {
      return {
        id: item.id ?? parts[0] ?? Math.random().toString(),
        type: parts[1] || DEFAULT_TYPE,
        title: parts[2] || "Duyuru",
        message: parts[3] || trimmedRaw,
        date: normalizedDate,
        createdAt,
        updatedAt: item.updatedAt,
        status: item.status || "SENT",
      };
    }
  }

  return {
    id: item.id ?? Math.random().toString(),
    type: DEFAULT_TYPE,
    title: "Bildirim",
    message: trimmedRaw || "Yeni bildirim",
    date: normalizedDate,
    createdAt,
    updatedAt: item.updatedAt,
    status: item.status || "SENT",
  };
};
